<template>

  <div>
    <b-card class="w-100" :title="item.name">

      <div class="row">
        <div class="col-md-9">
          <b-card-text>
            {{ item.detail }}
          </b-card-text>
          <b-card-text>
            Contacto: {{ item.user.name }}
          </b-card-text>

          <div class="row iconned">
            <div class="col">
              <font-awesome-icon class="fa-small-icon" icon="phone" />
              <a :href=phone(item)>
                <span class="icon icon-phone"></span>
                <span class="text"> Llamar</span>
              </a>
            </div>
          </div>

          <div class="row iconned">
            <div class="col">
              <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'whatsapp' }"/>
              <a target="__blank" :href=whatsappUrl(item)>
                <span class="icon whatsapp"></span>
                <span class="text"> Enviar Whatsapp </span>
              </a>
            </div>
          </div>

          <div class="row iconned">
            <div class="col">
              <font-awesome-icon class="fa-small-icon" icon="envelope" />
              <a :href=email(item)>
                <span class="icon icon-envelope"></span>
                <span class="text"> Enviar Correo</span>
              </a>
            </div>
          </div>

        </div>

        <div class="col-md-3">
          <div class="row" v-if="item.image.url">
            <figure class="img-container" style="margin: auto;">
              <img class="icon-img"
                :src="item.image.url || defaultImg"
                :alt="item.name">
              </figure>
            </div>
            <div class="row mt-3">
              <b-button style="float: right;margin: auto;"
                @click="showMore(item)"
                variant="primary">
                Ver detalle
              </b-button>
            </div>
          </div>
        </div>
      </b-card>

      <b-modal hide-footer
        ref="my-modal"
        :title="selected.name"
        v-if="selected"
        v-model="isModalActive">
        <div class="d-block text-center">
          <div class="cnt-block equal-hight"
            v-if="selected.image.url">
            <figure class="img-container">
              <img class="icon-img"
                :src="selected.image.url || defaultImg"
                :alt="selected.name">
              </figure>
            </div>
            <div class="card-content">
              <div class="content">
                <p class="detail">
                  {{ selected.detail }}
                </p>
                <p class="detail"
                  v-if="selected.deliveries">
                  <b>Formas de entrega</b>
                </p>
                <p class="detail"
                  v-for="item in selected.deliveries"
                  :key="item.name">
                  {{item.name}}
                </p>
                <p class="detail"
                  v-if="selected.social_medias">
                  <b>Redes sociales</b>
                </p>
                <p class="detail"
                  v-for="item in selected.social_medias"
                  :key="item.source">
                  <b>{{item.source}}:</b> {{item.name}}
                </p>
              </div>
            </div>
          </div>
        </b-modal>

      </div>
    </template>

<script>
import axios from 'axios';

export default {
  name: 'BusinessCard',
  props: {
    item: Object,
  },
  data: function () {
    return {
      isModalActive: false,
      selected: null,
      defaultImg: "https://res.cloudinary.com/dbl4yeqf9/image/upload/v1577149294/logos/k9corp_njlmb4.png"
    };
  },
  methods: {
    fetchSingle() {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/community/business-register-data?id=${this.selected.id}`)
        .then(response => {
          console.log(response.data)
          this.selected = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false
        })
    },
    showMore(obj) {
      this.isModalActive = true;
      this.selected = obj;
      this.fetchSingle();
    },
    phone(item) {
      const phone = item.user.phone.replace(/-/g, "");
      return `tel:+506${phone}`;
    },
    whatsappUrl(item) {
      const phone = item.user.phone.replace(/-/g, "");
      const whatsapp = `+506${phone}`;
      return `https://api.whatsapp.com/send?phone=${whatsapp}`
    },
    email(item) {
      const email = item.user.email;
      return `mailto: ${email}`
    },


  }
}
</script>

<style scoped>
.hr {
  background-color: #E6CE9E;
  margin: 0;
  height: 5px;
}
.w-100 {
  margin-bottom: 20px;
}
.detail {
  text-align: justify !important;
}
.icon-img{
  object-fit: cover;
  max-height: 100%;
  max-width: 100%;
  height: 200px;
  -webkit-filter: grayscale(0%);
  filter: grayscale(0%);
}
.img-container {
  max-height: 100%;
  max-width: 100%;
  display:inline-block;
  margin-bottom: 15px;
}
.container-fluid {
  min-height: 600px;
}
.iconned {
  cursor: pointer;
}
</style>

